import * as React from 'react';

interface IAboutMeV2Props {
    text?: string;
}

const AboutMeV2: React.FunctionComponent<IAboutMeV2Props> = ({text}) => {
  return (    <div className="relative shrink-0 w-full">
      <div className="content-stretch flex flex-col items-start px-[20px] relative w-full">
        <p className="font-['Manrope:Regular',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#334155] text-[12px] w-full whitespace-pre-wrap">
          {text || "About me description" }
        </p>
      </div>
    </div>) ;
};

export default AboutMeV2;
